// Auto-scroll on home page load and prevent scrolling above 80px
(function () {
  const MIN_SCROLL = 140;
  const ANNOUNCEMENT_OFFSET_VAR = '--announcement-bar-height';

  function syncHeaderAnnouncementOffset() {
    const announcementSection = document.querySelector('.announcement-bar-section');
    const isHidden = announcementSection && announcementSection.classList.contains('announcement-bar-section--hidden');
    const announcementHeight = (announcementSection && !isHidden) ? announcementSection.offsetHeight : 0;
    document.documentElement.style.setProperty(ANNOUNCEMENT_OFFSET_VAR, `${announcementHeight}px`);
  }

  function scrollDown() {
    if (window.innerWidth <= 749) return;
    setTimeout(function () {
      window.scrollTo({
        top: MIN_SCROLL,
        behavior: 'smooth'
      });
    }, 20);
  }

  // Prevent scrolling above the minimum
  function enforceMinScroll() {
    if (window.innerWidth <= 749) return;
    if (window.scrollY < MIN_SCROLL) {
      window.scrollTo({
        top: MIN_SCROLL,
        behavior: 'instant'
      });
    }
  }

  // Try multiple events to ensure initial scroll works
  if (document.readyState === 'complete') {
    syncHeaderAnnouncementOffset();
    scrollDown();
  } else {
    window.addEventListener('load', function () {
      syncHeaderAnnouncementOffset();
      scrollDown();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncHeaderAnnouncementOffset();
      scrollDown();
    });
  } else {
    syncHeaderAnnouncementOffset();
  }

  // Listen for scroll events and enforce minimum
  window.addEventListener('scroll', enforceMinScroll, { passive: true });
  window.addEventListener('resize', syncHeaderAnnouncementOffset);
  window.addEventListener('announcementBarClosed', syncHeaderAnnouncementOffset);
})();
